import format from 'format-number';

export function createNumberFilter(thousandSeparator: string = null, decimalSeparator: string = null, defaultDecimals: number = 2) {

    return function(value: number, decimals: number = defaultDecimals, padRight: number | boolean = -1): string {

        if(value === null || value === undefined){
            return null;
        }

        if(padRight === true){
            padRight = decimals;
        }
        else if(padRight === false){
            padRight = 0;
        }

        const i18n: any = this.context.i18n.global;

        return format({
            integerSeparator: thousandSeparator || i18n.t('core.formatting.number.thousandSeparator'),
            decimal: decimalSeparator || i18n.t('core.formatting.number.decimalSeparator'),
            round: decimals,
            padRight
        })(value);
    }
}

export const numberFilter = createNumberFilter();